import LandingBgImg from './assets/landing-bg.png'
import FanyNb from './assets/fany-nb.png'
import FanyColor from './assets/fany-color.png'

import Byconcept01 from './assets/byconcept-01.webp'
import Byconcept02 from './assets/byconcept-02.webp'
import Byconcept03 from './assets/byconcept-03.webp'
import Byconcept04 from './assets/byconcept-04.webp'
import Byconcept05 from './assets/byconcept-05.webp'
import Byconcept06 from './assets/byconcept-06.webp'
import ByconceptThumb from './assets/byconcept-thumb.webp'
import ByconceptLanding from './assets/byconcept-landing.webp'

import Subway01 from './assets/subway-01.png'
import Subway02 from './assets/subway-02.png'
import Subway03 from './assets/subway-03.png'
import Subway04 from './assets/subway-04.png'
import Subway05 from './assets/subway-05.png'
import SubwayThumb from './assets/subway-thumb.jpg'
import SubwayLanding from './assets/subway-landing.png'

import Protection01 from './assets/protection-01.png'
import Protection02 from './assets/protection-02.png'
import Protection03 from './assets/protection-03.png'
import Protection04 from './assets/protection-04.png'
import Protection05 from './assets/protection-05.png'
import ProtectionThumb from './assets/protection-thumb.jpg'
import ProtectionLanding from './assets/protection-landing.png'

import Passion01 from './assets/passion-01.png'
import Passion02 from './assets/passion-02.png'
import Passion03 from './assets/passion-03.png'
import Passion04 from './assets/passion-04.png'
import Passion05 from './assets/passion-05.png'
import Passion06 from './assets/passion-06.png'
import Passion07 from './assets/passion-07.png'
import Passion08 from './assets/passion-08.png'
import PassionThumb from './assets/passion-thumb.jpg'
import PassionLanding from './assets/passion-landing.png'

import Hypnose01 from './assets/hypnose-01.png'
import Hypnose02 from './assets/hypnose-02.png'
import Hypnose03 from './assets/hypnose-03.png'
import Hypnose04 from './assets/hypnose-04.png'
import Hypnose05 from './assets/hypnose-05.png'
import Hypnose06 from './assets/hypnose-06.png'
import HypnoseThumb from './assets/hypnose-thumb.jpg'
import HypnoseLanding from './assets/hypnose-landing.png'

import Illus01 from './assets/illus-01.webp'
import Illus02 from './assets/illus-02.webp'
import Illus03 from './assets/illus-03.webp'
import Illus04 from './assets/illus-04.webp'
import Illus05 from './assets/illus-05.webp'
import Illus06 from './assets/illus-06.webp'
import Illus07 from './assets/illus-07.webp'
import Illus08 from './assets/illus-08.webp'
import IllusThumb from './assets/illus-thumb.webp'
import IllusLanding from './assets/illus-landing.webp'

import Realease01 from './assets/realease-01.png'
import Realease02 from './assets/realease-02.png'
import Realease03 from './assets/realease-03.png'
import Realease04 from './assets/realease-04.png'
import RealeaseThumb from './assets/realease-thumb.jpg'
import RealeaseLanding from './assets/realease-landing.png'

import Organilog01 from './assets/organilog-01.png'
import Organilog02 from './assets/organilog-02.png'
import Organilog03 from './assets/organilog-03.png'
import Organilog04 from './assets/organilog-04.png'
import Organilog05 from './assets/organilog-05.png'
import Organilog06 from './assets/organilog-06.png'
import Organilog07 from './assets/organilog-07.png'
import OrganilogThumb from './assets/organilog-thumb.jpg'
import OrganilogLanding from './assets/organilog-landing.png'

import Decidoc01 from './assets/decidoc-01.png'
import Decidoc02 from './assets/decidoc-02.png'
import Decidoc03 from './assets/decidoc-03.png'
import Decidoc04 from './assets/decidoc-04.png'
import Decidoc05 from './assets/decidoc-05.png'
import Decidoc06 from './assets/decidoc-06.png'
import DecidocThumb from './assets/decidoc-thumb.jpg'
import DecidocLanding from './assets/decidoc-landing.png'

import Histoire01 from './assets/histoire-01.png'
import Histoire02 from './assets/histoire-02.png'
import Histoire03 from './assets/histoire-03.png'
import Histoire04 from './assets/histoire-04.png'
import Histoire05 from './assets/histoire-05.png'
import Histoire06 from './assets/histoire-06.png'
import Histoire07 from './assets/histoire-07.png'
import Histoire08 from './assets/histoire-08.png'
import HistoireThumb from './assets/histoire-thumb.jpg'
import HistoireLanding from './assets/histoire-landing.png'

import Dentaire01 from './assets/dentaire-01.png'
import Dentaire02 from './assets/dentaire-02.png'
import Dentaire03 from './assets/dentaire-03.png'
import Dentaire04 from './assets/dentaire-04.png'
import DentaireThumb from './assets/dentaire-thumb.jpg'
import DentaireLanding from './assets/dentaire-landing.png'

import Mamanvogue01 from './assets/mamanvogue-01.webp'
import Mamanvogue02 from './assets/mamanvogue-02.webp'
import Mamanvogue03 from './assets/mamanvogue-03.webp'
import Mamanvogue04 from './assets/mamanvogue-04.webp'
import Mamanvogue05 from './assets/mamanvogue-05.webp'
import MamanvogueThumb from './assets/mamanvogue-thumb.webp'
import MamanvogueLanding from './assets/mamanvogue-landing.webp'

import Alpaga01 from './assets/alpaga-01.png'
import Alpaga02 from './assets/alpaga-02.png'
import Alpaga03 from './assets/alpaga-03.png'
import Alpaga04 from './assets/alpaga-04.png'
import Alpaga05 from './assets/alpaga-05.png'
import Alpaga06 from './assets/alpaga-06.png'
import AlpagaThumb from './assets/alpaga-thumb.jpg'
import AlpagaLanding from './assets/alpaga-landing.png'

export default {
  home: [
    { id: 'landingBg', src: LandingBgImg },

    { id: 'byconceptThumb', src: ByconceptThumb },
    { id: 'subwayThumb', src: SubwayThumb },
    { id: 'protectionThumb', src: ProtectionThumb },
    { id: 'passionThumb', src: PassionThumb },
    { id: 'hypnoseThumb', src: HypnoseThumb },
    { id: 'illusThumb', src: IllusThumb },
    { id: 'realeaseThumb', src: RealeaseThumb },
    { id: 'organilogThumb', src: OrganilogThumb },
    { id: 'decidocThumb', src: DecidocThumb },
    { id: 'histoireThumb', src: HistoireThumb },
    { id: 'dentaireThumb', src: DentaireThumb },
    { id: 'mamanvogueThumb', src: MamanvogueThumb },
    { id: 'alpagaThumb', src: AlpagaThumb },

    { id: 'fanyNb', src: FanyNb },
    { id: 'fanyColor', src: FanyColor },
  ],

  byconcept: [
    { id: 'byconcept01', src: Byconcept01 },
    { id: 'byconcept02', src: Byconcept02 },
    { id: 'byconcept03', src: Byconcept03 },
    { id: 'byconcept04', src: Byconcept04 },
    { id: 'byconcept05', src: Byconcept05 },
    { id: 'byconcept06', src: Byconcept06 },
    { id: 'subwayThumb', src: SubwayThumb },
    { id: 'byconceptLanding', src: ByconceptLanding },
  ],

  subway: [
    { id: 'subway01', src: Subway01 },
    { id: 'subway02', src: Subway02 },
    { id: 'subway03', src: Subway03 },
    { id: 'subway04', src: Subway04 },
    { id: 'subway05', src: Subway05 },
    { id: 'protectionThumb', src: ProtectionThumb },
    { id: 'subwayLanding', src: SubwayLanding },
  ],

  protection: [
    { id: 'protection01', src: Protection01 },
    { id: 'protection02', src: Protection02 },
    { id: 'protection03', src: Protection03 },
    { id: 'protection04', src: Protection04 },
    { id: 'protection05', src: Protection05 },
    { id: 'passionThumb', src: PassionThumb },
    { id: 'protectionLanding', src: ProtectionLanding },
  ],

  passion: [
    { id: 'passion01', src: Passion01 },
    { id: 'passion02', src: Passion02 },
    { id: 'passion03', src: Passion03 },
    { id: 'passion04', src: Passion04 },
    { id: 'passion05', src: Passion05 },
    { id: 'passion06', src: Passion06 },
    { id: 'passion07', src: Passion07 },
    { id: 'passion08', src: Passion08 },
    { id: 'hypnoseThumb', src: HypnoseThumb },
    { id: 'passionLanding', src: PassionLanding },
  ],

  hypnose: [
    { id: 'hypnose01', src: Hypnose01 },
    { id: 'hypnose02', src: Hypnose02 },
    { id: 'hypnose03', src: Hypnose03 },
    { id: 'hypnose04', src: Hypnose04 },
    { id: 'hypnose05', src: Hypnose05 },
    { id: 'hypnose06', src: Hypnose06 },
    { id: 'illusThumb', src: IllusThumb },
    { id: 'hypnoseLanding', src: HypnoseLanding },
  ],

  illus: [
    { id: 'illus01', src: Illus01 },
    { id: 'illus02', src: Illus02 },
    { id: 'illus03', src: Illus03 },
    { id: 'illus04', src: Illus04 },
    { id: 'illus05', src: Illus05 },
    { id: 'illus06', src: Illus06 },
    { id: 'illus07', src: Illus07 },
    { id: 'illus08', src: Illus08 },
    { id: 'realeaseThumb', src: RealeaseThumb },
    { id: 'illusLanding', src: IllusLanding },
  ],

  realease: [
    { id: 'realease01', src: Realease01 },
    { id: 'realease02', src: Realease02 },
    { id: 'realease03', src: Realease03 },
    { id: 'realease04', src: Realease04 },
    { id: 'organilogThumb', src: OrganilogThumb },
    { id: 'realeaseLanding', src: RealeaseLanding }
  ],

  organilog: [
    { id: 'organilog01', src: Organilog01 },
    { id: 'organilog02', src: Organilog02 },
    { id: 'organilog03', src: Organilog03 },
    { id: 'organilog04', src: Organilog04 },
    { id: 'organilog05', src: Organilog05 },
    { id: 'organilog06', src: Organilog06 },
    { id: 'organilog07', src: Organilog07 },
    { id: 'decidocThumb', src: DecidocThumb },
    { id: 'organilogLanding', src: OrganilogLanding }
  ],

  decidoc: [
    { id: 'decidoc01', src: Decidoc01 },
    { id: 'decidoc02', src: Decidoc02 },
    { id: 'decidoc03', src: Decidoc03 },
    { id: 'decidoc04', src: Decidoc04 },
    { id: 'decidoc05', src: Decidoc05 },
    { id: 'decidoc06', src: Decidoc06 },
    { id: 'histoireThumb', src: HistoireThumb },
    { id: 'decidocLanding', src: DecidocLanding },
  ],

  histoire: [
    { id: 'histoire01', src: Histoire01 },
    { id: 'histoire02', src: Histoire02 },
    { id: 'histoire03', src: Histoire03 },
    { id: 'histoire04', src: Histoire04 },
    { id: 'histoire05', src: Histoire05 },
    { id: 'histoire06', src: Histoire06 },
    { id: 'histoire07', src: Histoire07 },
    { id: 'histoire08', src: Histoire08 },
    { id: 'dentaireThumb', src: DentaireThumb },
    { id: 'histoireLanding', src: HistoireLanding },
  ],
  
  dentaire: [
    { id: 'dentaire01', src: Dentaire01 },
    { id: 'dentaire02', src: Dentaire02 },
    { id: 'dentaire03', src: Dentaire03 },
    { id: 'dentaire04', src: Dentaire04 },
    { id: 'mamanvogueThumb', src: MamanvogueThumb },
    { id: 'dentaireLanding', src: DentaireLanding }
  ],

  mamanvogue: [
    { id: 'mamanvogue01', src: Mamanvogue01 },
    { id: 'mamanvogue02', src: Mamanvogue02 },
    { id: 'mamanvogue03', src: Mamanvogue03 },
    { id: 'mamanvogue04', src: Mamanvogue04 },
    { id: 'mamanvogue05', src: Mamanvogue05 },
    { id: 'alpagaThumb', src: AlpagaThumb },
    { id: 'mamanvogueLanding', src: MamanvogueLanding },
  ],

  alpaga: [
    { id: 'alpaga01', src: Alpaga01 },
    { id: 'alpaga02', src: Alpaga02 },
    { id: 'alpaga03', src: Alpaga03 },
    { id: 'alpaga04', src: Alpaga04 },
    { id: 'alpaga05', src: Alpaga05 },
    { id: 'alpaga06', src: Alpaga06 },
    { id: 'byconceptThumb', src: ByconceptThumb },
    { id: 'alpagaLanding', src: AlpagaLanding },
  ],
}



// WEBPACK FOOTER //
// ./src/preload-manifest.js